import * as React from 'react';

import { cn } from '@/lib/ui-kit/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        `hover:border-border shadow-xs selection:bg-primary selection:text-primary-foreground text-foreground
        placeholder:text-muted-foreground dark:bg-input light:bg-white font-body-medium flex w-full min-w-0
        appearance-none rounded-md border border-transparent bg-white px-4 py-2
        transition-[color,box-shadow,border-color,outline-color] duration-200 file:inline-flex file:h-12
        file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none
        disabled:cursor-not-allowed disabled:opacity-50`,
        'focus-visible:outline-primary h-10 focus-visible:outline md:h-10',
        `aria-invalid:border-destructive aria-invalid:focus-visible:outline-destructive
        hover:outline-primary-hover hover:outline focus:outline`,
        className,
      )}
      {...props}
    />
  );
}

export { Input };
